(function () {
  const sections = document.querySelectorAll('.js-brands-directory-new');

  sections.forEach((section) => {
    const alphabetLinks = section.querySelectorAll('.js-bdn-alphabet-link');
    let letterBlocks = Array.from(
      section.querySelectorAll('.brands-directory-new__az-content .js-bdn-letter-block')
    );
    const tabs = section.querySelectorAll('.js-bdn-tab');
    const toolbar = section.querySelector('.js-bdn-toolbar');
    const searchInput = section.querySelector('.js-bdn-search-input');
    const searchNoResults = section.querySelector('.js-bdn-search-no-results');
    const azBrandCards = section.querySelectorAll('.brands-directory-new__az-content .js-bdn-brand-card');

    let scrollLockUntil = 0;
    let currentActiveLetter = '';
    let activeBlockIndex = 0;
    let lastScrollY = window.scrollY;
    let scrollTicking = false;
    let pendingLetter = '';
    let pendingLetterSince = 0;

    const SCROLL_ENTER_OFFSET = 56;
    const SCROLL_EXIT_OFFSET = 20;
    const LETTER_CHANGE_DELAY = 90;

    function refreshLetterBlocks() {
      letterBlocks = Array.from(
        section.querySelectorAll('.brands-directory-new__az-content .js-bdn-letter-block')
      );
    }

    function reconcileBrandGroups() {
      const sectionsRoot = section.querySelector(
        '.brands-directory-new__az-content .brands-directory-new__sections'
      );
      if (!sectionsRoot) return;

      const blockByLetter = new Map();
      sectionsRoot.querySelectorAll('.js-bdn-letter-block').forEach((block) => {
        const letter = block.dataset.letter;
        if (!letter) return;

        const cardsContainer = block.querySelector('.brands-directory-new__cards');
        if (!cardsContainer) return;

        if (!blockByLetter.has(letter)) {
          blockByLetter.set(letter, cardsContainer);
          return;
        }

        const primaryContainer = blockByLetter.get(letter);
        cardsContainer.querySelectorAll('.js-bdn-brand-card').forEach((card) => {
          primaryContainer.appendChild(card);
        });
        block.remove();
      });

      refreshLetterBlocks();
    }

    function updateToolbarMetrics() {
      if (!toolbar) return;
      section.style.setProperty('--bdn-toolbar-height', `${toolbar.offsetHeight}px`);
    }

    function getActivationLine() {
      if (toolbar) {
        return toolbar.getBoundingClientRect().bottom + 4;
      }
      return 140;
    }

    function getBlockHeaderTop(block) {
      const header = block.querySelector('.brands-directory-new__letter-header');
      return (header || block).getBoundingClientRect().top;
    }

    function resolveActiveBlockIndex() {
      if (!letterBlocks.length) return 0;

      const line = getActivationLine();
      const doc = document.documentElement;
      const atBottom = window.innerHeight + window.scrollY >= doc.scrollHeight - 40;
      const scrollY = window.scrollY;
      const scrollingDown = scrollY >= lastScrollY - 2;
      lastScrollY = scrollY;

      if (atBottom) {
        return letterBlocks.length - 1;
      }

      let index = activeBlockIndex;

      if (scrollingDown) {
        while (index < letterBlocks.length - 1) {
          const nextTop = getBlockHeaderTop(letterBlocks[index + 1]);
          if (nextTop <= line - SCROLL_ENTER_OFFSET) {
            index += 1;
          } else {
            break;
          }
        }
      } else {
        while (index > 0) {
          const currentTop = getBlockHeaderTop(letterBlocks[index]);
          if (currentTop > line + SCROLL_EXIT_OFFSET) {
            index -= 1;
          } else {
            break;
          }
        }
      }

      if (getBlockHeaderTop(letterBlocks[0]) > line + 80) {
        index = 0;
      }

      return index;
    }

    function applyActiveLetter(letter, blockIndex) {
      if (!letter || letter === currentActiveLetter) return;

      currentActiveLetter = letter;
      activeBlockIndex = blockIndex;
      setActiveLetter(section, letter);
    }

    function setViewMode(mode) {
      section.classList.remove('is-search-mode', 'is-categories-mode');

      if (mode === 'search') {
        section.classList.add('is-search-mode');
      } else if (mode === 'categories') {
        section.classList.add('is-categories-mode');
      }

      updateToolbarMetrics();
    }

    function updateScrollSpy() {
      if (Date.now() < scrollLockUntil) return;
      if (section.classList.contains('is-search-mode')) return;
      if (section.classList.contains('is-categories-mode')) return;
      if (!letterBlocks.length) return;

      const blockIndex = resolveActiveBlockIndex();
      const letter = letterBlocks[blockIndex].dataset.letter || '';

      if (!letter || letter === currentActiveLetter) {
        pendingLetter = '';
        return;
      }

      const now = Date.now();

      if (pendingLetter !== letter) {
        pendingLetter = letter;
        pendingLetterSince = now;
        return;
      }

      if (now - pendingLetterSince < LETTER_CHANGE_DELAY) return;

      pendingLetter = '';
      applyActiveLetter(letter, blockIndex);
    }

    function onScroll() {
      if (!scrollTicking) {
        scrollTicking = true;
        requestAnimationFrame(() => {
          updateScrollSpy();
          scrollTicking = false;
        });
      }
    }

    updateToolbarMetrics();
    reconcileBrandGroups();
    activeBlockIndex = resolveActiveBlockIndex();
    currentActiveLetter = letterBlocks[activeBlockIndex]?.dataset.letter || '';
    if (currentActiveLetter) setActiveLetter(section, currentActiveLetter);

    window.addEventListener('resize', updateToolbarMetrics, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('load', () => {
      updateToolbarMetrics();
      reconcileBrandGroups();
      updateScrollSpy();
    });

    alphabetLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;

        const target = section.querySelector(href);
        if (!target) return;

        event.preventDefault();
        const letter = link.dataset.letter;
        scrollLockUntil = Date.now() + 1200;
        pendingLetter = '';
        activeBlockIndex = letterBlocks.findIndex((block) => block.dataset.letter === letter);
        if (activeBlockIndex < 0) activeBlockIndex = 0;
        currentActiveLetter = letter;
        setActiveLetter(section, letter, { scrollAlphabet: true, smoothAlphabet: true });
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        if (tab.classList.contains('js-bdn-tab-categories')) {
          setViewMode('categories');
          setActiveTab(tabs, tab);
          if (searchInput) searchInput.value = '';
          clearBrandFilter();
          return;
        }

        if (tab.classList.contains('js-bdn-tab-search')) {
          setViewMode('search');
          setActiveTab(tabs, tab);
          filterBrands(searchInput ? searchInput.value : '');
          if (searchInput) searchInput.focus();
          return;
        }

        if (tab.classList.contains('js-bdn-tab-az')) {
          setViewMode('az');
          setActiveTab(tabs, tab);
          if (searchInput) searchInput.value = '';
          clearBrandFilter();
          reconcileBrandGroups();
          requestAnimationFrame(updateScrollSpy);
        }
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        if (!section.classList.contains('is-search-mode')) return;
        filterBrands(searchInput.value);
      });

      searchInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          searchInput.value = '';
          filterBrands('');
        }
      });
    }

    function filterBrands(rawQuery) {
      const query = rawQuery.trim().toLowerCase();
      let visibleCount = 0;

      azBrandCards.forEach((card) => {
        const name = (card.dataset.brandName || '').toLowerCase();
        const match = !query || name.includes(query);
        card.classList.toggle('is-search-hidden', !match);
        if (match) visibleCount += 1;
      });

      letterBlocks.forEach((block) => {
        const hasVisible = block.querySelector('.js-bdn-brand-card:not(.is-search-hidden)');
        block.classList.toggle('is-search-hidden', query.length > 0 && !hasVisible);
      });

      if (searchNoResults) {
        searchNoResults.hidden = !query || visibleCount > 0;
      }
    }

    function clearBrandFilter() {
      filterBrands('');
      if (searchNoResults) searchNoResults.hidden = true;
    }
  });

  function setActiveLetter(section, letter, options) {
    if (!letter) return;

    const opts = options || {};
    const scrollAlphabet = opts.scrollAlphabet === true;
    const smoothAlphabet = opts.smoothAlphabet === true;
    const revealInStrip = opts.revealInStrip === true;

    section.querySelectorAll('.js-bdn-alphabet-link').forEach((link) => {
      const isMatch = link.dataset.letter === letter;
      link.classList.toggle('is-active', isMatch);

      if (!isMatch || !link.scrollIntoView) return;

      if (scrollAlphabet) {
        link.scrollIntoView({
          behavior: smoothAlphabet ? 'smooth' : 'auto',
          block: 'nearest',
          inline: 'center',
        });
        return;
      }

      if (revealInStrip) {
        const wrap = link.closest('.brands-directory-new__alphabet-wrap');
        if (!wrap) return;

        const linkRect = link.getBoundingClientRect();
        const wrapRect = wrap.getBoundingClientRect();

        if (linkRect.left < wrapRect.left + 8 || linkRect.right > wrapRect.right - 8) {
          link.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
        }
      }
    });

    section.querySelectorAll('.js-bdn-letter-block').forEach((block) => {
      block.classList.toggle('is-accent', block.dataset.letter === letter);
    });
  }

  function setActiveTab(tabElements, activeTab) {
    tabElements.forEach((t) => {
      t.classList.remove('is-active');
      t.removeAttribute('aria-current');
    });
    activeTab.classList.add('is-active');
    if (
      activeTab.classList.contains('js-bdn-tab-az') ||
      activeTab.classList.contains('js-bdn-tab-categories') ||
      activeTab.classList.contains('js-bdn-tab-search')
    ) {
      activeTab.setAttribute('aria-current', 'page');
    }
  }
})();
